<div class="omni-shell">
  @if (!isLoginPage) {
    <app-sidebar
      [open]="sidebarOpen"
      [collapsed]="sidebarCollapsed"
      (sidebarClosed)="sidebarOpen = false"
    ></app-sidebar>
  }

  <div class="omni-content">
    @if (isHeaderVisible) {
      <header class="page-header">
        <div class="page-header__left">
          <button
            type="button"
            class="hamburger-btn"
            (click)="toggleSidebar()"
            aria-label="Toggle navigation"
            data-testid="app-hamburger-button"
          >
            <Symbol name="menu"></Symbol>
          </button>
        </div>
        <div class="page-header__right">
          <!-- @if (!isAdminRoute && !isDashboardPage) { -->
          <app-dropdown-menu
            [selectedLabel]="selectedLabel || 'Select Location'"
            [menuItems]="dccCodeMenuItems()"
            (menuItemSelected)="onDccMenuItemClick($event)"
          ></app-dropdown-menu>
          <!-- } -->
          <app-downloads-button></app-downloads-button>
          <app-user-menu></app-user-menu>
        </div>
      </header>
    }
    <main class="omni-main">
      <app-spinner></app-spinner>
      <router-outlet></router-outlet>
    </main>
    @if (!isLoginPage) {
      <div
        oui-page-footer
        [sectionText]="
          '© ' + currentYear + ' Assurant, Inc. All rights reserved.'
        "
        versionText="v3.0"
      ></div>
    }
  </div>
  <app-toast></app-toast>
</div>
